import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const useAcquisitionAnalyticsStore = create(
  persist(
    (set) => ({
      analytics: null,
      setAnalytics: (analytics) => {
        set({ analytics });
      },
    }),
    {
      name: 'acquisition-analytics',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
